import api from "../../api/shadhin";
import router from "../../router";
// Firebase config
import { deleteToken, getToken } from "firebase/messaging";
import messaging from "../../firebase";

const state = {
  token: window.localStorage.getItem("shadhin_token"),
  cancelTokens: [], // axios cancel tokens
  error: "",
  errorStatus: "",
  successStatus: "",
  responseMsg: "",
  test: "",
  networkErrorStatus: false,
  adminName: localStorage.getItem("name"),
  adminEmail: localStorage.getItem("email"),
};

const getters = {
  isLoggedIn: (state) => {
    return !!state.token;
  },
  getMenus: (state) => {
    if (!state.token) {
      return [
        {
          title: "Login",
          items: [
            { icon: "app_registration", title: "Sign up", link: "/signup" },
            { icon: "login", title: "Sign in", link: "/signin" },
          ],
        },
      ];
    } else {
      return [
        {
          title: "Settings",
          items: [
            { icon: "", title: "Division", link: "/division" },
            { icon: "", title: "District", link: "/district" },
            { icon: "", title: "Gender", link: "/gender" },
            { icon: "", title: "Marital Status", link: "/marital-status" },
            { icon: "", title: "Gov Approved Id", link: "/gov-approved-id" },
            { icon: "", title: "Employment Type", link: "/employment-type" },
            {
              icon: "",
              title: "Employment Detail",
              link: "/employment-type-detail",
            },
            // {icon:'', title: 'Employment Info', link: '/employment-type-detail'},
            {
              icon: "",
              title: "Monthly Income Type",
              link: "/monthly-income-type",
            },
            {
              icon: "",
              title: "Education Qualification Type",
              link: "/educational-qualification-type",
            },
            { icon: "", title: "Account Type", link: "/account-type" },
            { icon: "", title: "Contacts", link: "/contacts" },
            { icon: "", title: "OTP Credentials", link: "/otp-credential" },
            { icon: "", title: "SMSs", link: "/otp-sms" },
            { icon: "", title: "FAQs", link: "/faq" },
            { icon: "", title: "User Types", link: "/user-type" },
          ],
        },
        {
          title: "Investee",
          items: [
            { icon: "", title: "Investee", link: "/investee" },
            {
              icon: "",
              title: "Investee All Data",
              link: "/investee-all-data",
            },
            { icon: "", title: "Settings Section", link: "" },
            {
              icon: "",
              title: "Fund Application Statuses",
              link: "/fund-status-list",
            },
            { icon: "", title: "Emi Statuses", link: "/emi-status-list" },
            { icon: "", title: "Loan Purposes", link: "/loan-purposes" },
            { icon: "", title: "House Types", link: "/house-type" },
            { icon: "", title: "All Fees", link: "/all-fee" },
            // {icon:'', title: 'Score Calculator', link: '/employment-type'},
          ],
        },
        {
          title: "Investor",
          items: [
            {
              icon: "attach_money",
              title: "Add Fund Request",
              link: "/add-fund",
            },
            { icon: "payment", title: "Withdrawals", link: "/withdraw" },
            { icon: "settings", title: "Settings Section", link: "" },
            {
              icon: "account_balance",
              title: "Net Worth Amount",
              link: "/net-worth-type",
            },
            { icon: "quiz", title: "Questions", link: "/investor-question" },
            {
              icon: "question_answer",
              title: "Answers",
              link: "/investor-answer",
            },
            {
              icon: "calculate",
              title: "Investor Calculator Settings",
              link: "/calculator-setting",
            },
            {
              icon: "price_change",
              title: "Money Adjustment Statuses",
              link: "/money-adjust-status",
            },
            {
              icon: "credit_score",
              title: "Investor Payment Methods",
              link: "/payment-method",
            },
            {
              icon: "account_balance_wallet",
              title: "Wallet Types",
              link: "/wallet-type",
            },
            {
              icon: "work_outline",
              title: "Invest Experience Types",
              link: "/invest-experience-type",
            },
            {
              icon: "warning",
              title: "Invest Risk Types",
              link: "/invest-risk-type",
            },
          ],
        },

        {
          title: "Shadhin",
          items: [
            { title: "Make Payment", icon: "payments", link: "/make-payment" },
            {
              title: "Validate NID",
              icon: "how_to_reg",
              link: "/validate-nid",
            },
            {
              title: "Loan Products",
              icon: "auto_awesome_motion",
              link: "/loan-products",
            },
            { title: "Fundings", icon: "attach_money", link: "/funding" },
            {
              title: "Account Deletion Requests",
              icon: "delete",
              link: `${process.env.VUE_APP_NEW_FRONTEND_URL}/account-deletion-requests`,
              external: true,
            },
            { title: "Users", icon: "group", link: "/users" },

            { title: "Invitation", icon: "group_add", link: "/invitation" },
            {
              title: "Role Permission",
              icon: "admin_panel_settings",
              link: "",
            },
            { title: "Url", icon: "link", link: "/url" },
            { title: "Role", icon: "work", link: "/role" },
            { title: "Url To Role", icon: "add_link", link: "/url-role" },
            { title: "Official User", icon: "badge", link: "/official-user" },
            {
              title: "Role To User",
              icon: "supervisor_account",
              link: "/role-user",
            },
          ],
        },
        // {
        //   title: "Profile",
        //   items: [
        //     {
        //       icon: "password",
        //       title: "Update Password",
        //       link: "/update-password",
        //     },
        //   ],
        // },
      ];
    }
  },
  getAuthResponse: (state) => {
    if (state.error) {
      return state.responseMsg;
    }
  },
  getAuthSigninResponse: (state) => {
    if (state.error) {
      return state.responseMsg;
    }
  },
};

const actions = {
  CANCEL_PENDING_REQUESTS({ state, commit }) {
    // Cancel all axios requests where a cancel token exists
    state.cancelTokens.forEach((request) => {
      if (request.cancel) {
        request.cancel();
      }
    });

    // Reset the axios cancelTokens store
    commit("CLEAR_CANCEL_TOKENS");
  },
  async login({ commit }, allLogData) {
    const response = await api.login(allLogData, "login");
    if (response.data.error == 1) {
      commit("setAuthResponse", response);
      router.push("/signin");
    } else {
      commit("setToken", response);
      window.localStorage.setItem(
        "shadhin_token",
        response.data.data.users.api_token
      );
      window.localStorage.setItem("name", response.data.data.users.name);
      window.localStorage.setItem("email", response.data.data.users.email);
      commit("setNameEmail", {
        name: response.data.data.users.name,
        email: response.data.data.users.email,
      });
      setDeviceToken();
      router.push("/");
    }
  },

  async register({ commit }, allRegData) {
    const response = await api.register(allRegData, "signup");
    if (response.data.error) {
      commit("setAuthResponse", response);
      router.push("/signup");
    } else {
      commit("setToken", response);
      window.localStorage.setItem(
        "shadhin_token",
        response.data.data.users.api_token
      );
      router.push("/");
    }
  },

  async logout({ commit }) {
    // we use commit instead of mutations there are several reasons for that. there might be several request
    commit("setToken", "");
    window.localStorage.removeItem("shadhin_token");
    router.push("/signin");
  },

  networkError({ commit }) {
    commit("setNetworkError");
  },
};

const mutations = {
  setToken: (state, response) => {
    if (response == "") {
      state.token = "";
    } else {
      state.token = response.data.data.users.api_token;
      state.successStatus = response.statusCode;
      state.responseMsg = response.errorMsg;
    }
  },

  // Add axios cancel token
  ADD_CANCEL_TOKEN(state, token) {
    state.cancelTokens.push(token);
  },
  // clear all axios cancel token
  CLEAR_CANCEL_TOKENS(state) {
    state.cancelTokens = [];
  },
  setTest: (state, response) => {
    state.test = response;
  },
  setAuthResponse: (state, response) => {
    state.test = response;
    state.error = response.data.error;
    state.errorStatus = response.data.statusCode;
    state.responseMsg = response.data.errorMsg;
  },
  setNameEmail: (state, nameEmail) => {
    // state.test = responseData
    state.adminName = nameEmail.name;
    state.adminEmail = nameEmail.email;
  },
  setNetworkError: (state) => {
    state.networkErrorStatus = !state.networkErrorStatus;
  },
};

/**
 * Set Firebase Device Token
 */
const setDeviceToken = async () => {
  // Delete previous token from firebase first
  await deleteToken(messaging);

  // Get registration token. Initially this makes a network call, once retrieved
  // subsequent calls to getToken will return from cache.
  getToken(messaging, {
    vapidKey:
      "BFqKeS5q75p25k8hPfSpPF0w_LB5RW8ioqP3lgr78r7vTRXArk-thgUZtgDqsIldF8hF640XAkI6r5Tmz1VJq7w",
  }).then(async (currentToken) => {
    if (currentToken) {
      // Send the token to your server and update the UI if necessary
      // console.log(currentToken);
      // this.$store.dispatch("store", [
      //   "fcm-token",
      //   { device_token: currentToken },
      // ]);
      const shadhin_token = localStorage.getItem("shadhin_token");
      const response = await api.storeData(shadhin_token, "fcm-token", {
        device_token: currentToken,
      });
      // keep token in the local storage
      localStorage.setItem("deviceTokenId", response.data.data.id);
    }
    // else {
    //   // Show permission request UI
    //   console.log(
    //     "No registration token available. Request permission to generate one."
    //   );
    // }
  });
  // .catch((err) => {
  // console.log("An error occurred while retrieving token. ", err);
  // });
};

export default {
  state,
  getters,
  actions,
  mutations,
};
